import { IconContentLink } from '@doltech/icons/IconContentLink';
import { getLandingUrlFromPath } from '@doltech/utils/lib/url';
import * as React from 'react';
import styled from 'styled-components';
import { useClipboard } from 'use-clipboard-copy';

import { Typography } from '../../../DesignSystemV2/Typography';
import { DolTooltip } from '../../../Tooltip/DolTooltip';

const Main = styled.div`
  display: grid;
  grid-auto-flow: column;
  grid-auto-columns: minmax(0, max-content);
  align-items: center;
  cursor: pointer;
  transition: all 0.3s ease;
  gap: 8px;
  height: 100%;
  .icon {
    font-size: 20px;
    line-height: 0;
  }
`;

export const CopyLinkButton = ({ url }) => {
  const clipboard = useClipboard({
    copiedTimeout: 2000,
  });
  return (
    <DolTooltip
      className="copy-link-btn-tooltip"
      title={clipboard.copied ? 'Đã sao chép' : 'sao chép'}
      placement="bottom"
      trigger={['click']}
      visible={clipboard.copied}
    >
      <div
        key="copy"
        onClick={() => {
          clipboard.copy(getLandingUrlFromPath(url));
        }}
      >
        <Main className="social-button copy-link-btn">
          <div className="icon">
            <IconContentLink />
          </div>
          <Typography.Paragraph className="text">Copy link</Typography.Paragraph>
        </Main>
      </div>
    </DolTooltip>
  );
};
